<template lang='pug'>
  i.svg-icon.svg-icon-edge
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(fill='#368BCB' d='M9.221,44.852h0.049c0.525-4.143,1.49-8.109,2.886-11.91c1.396-3.8,3.287-7.364,5.671-10.702 c2.383-3.336,5.135-6.227,8.258-8.677c3.122-2.449,6.796-4.38,11.021-5.792s8.771-2.118,13.631-2.118 c7.596,0,14.397,1.732,20.415,5.202c6.019,3.469,10.845,8.456,14.497,14.965c3.419,6.145,5.13,13.41,5.13,21.794v9.269H35.303 c0.032,3.646,0.91,6.812,2.637,9.492c1.726,2.681,3.971,4.694,6.729,6.042c2.758,1.346,5.875,2.282,9.344,2.808 c3.47,0.523,6.968,0.573,10.503,0.148c3.535-0.426,6.95-1.191,10.255-2.295c3.304-1.104,6.157-2.487,8.556-4.165v18.591 c-3.023,1.809-6.796,3.319-11.313,4.533c-4.519,1.215-9.654,1.843-15.408,1.875c-5.752,0.033-10.943-0.839-15.583-2.614 c-6.211-2.399-11.33-6.492-15.357-12.274c-4.027-5.779-6.074-11.903-6.14-18.347c-0.099-7.954,1.727-14.723,5.472-20.31 c3.747-5.589,9.092-9.997,16.025-13.218c-1.578,1.975-2.857,4.038-3.845,6.189c-0.987,2.151-1.743,4.777-2.267,7.867h31.31 c0.264-2.532,0.132-4.833-0.397-6.901c-0.524-2.069-1.297-3.74-2.317-5.003s-2.179-2.361-3.476-3.277 c-1.296-0.921-2.619-1.594-3.972-2.019c-1.345-0.424-2.58-0.767-3.695-1.009c-1.113-0.244-2.035-0.387-2.764-0.42l-1.081-0.06 c-4.435,0.165-8.704,0.893-12.798,2.195c-4.093,1.302-7.761,3.018-11.016,5.152c-3.254,2.135-6.15,4.446-8.677,6.928 C13.502,39.275,11.224,41.961,9.221,44.852z')


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};

</script>
